module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-preview"
  }, [_vm._v("\n  " + _vm._s(_vm.tags) + "\n  " + _vm._s(_vm.itemtype) + "\n  " + _vm._s(_vm.itemkey) + "\n  " + _vm._s(_vm.tags_list) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d81f69f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsPreview.vue
// module id = 626
// module chunks = 1